import { Record } from 'immutable'

export class TransportState extends Record({
    id: undefined,
    name: undefined,
    rgb_bg: undefined,
    rgb_text: undefined,
    order: undefined,
}) {}
